(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mxe-header"]) return;
  try {
    
  class MxeStickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('mxe-sticky-header', MxeStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    

function initializeKivoraQuiz(root){
'use strict';
const settings=JSON.parse(root.querySelector('[data-quiz-config]').textContent);
let placementObserver=null,placementTimeout=null,placementFrame=null;
function placeQuiz(){
 if(settings.placement!=='above_bundle')return true;
 const bundleElement=document.querySelector('main kaching-bundles-block');
 const bundle=bundleElement?.closest('.shopify-block')||bundleElement;
 const host=root.closest('.shopify-section')||root;
 if(bundle&&!host.contains(bundle)&&host.nextElementSibling!==bundle){bundle.before(host);return true;}
 return !!bundle;
}
placementFrame=requestAnimationFrame(()=>{if(!root.isConnected)return;if(!placeQuiz()){
 placementObserver=new MutationObserver(()=>{if(placeQuiz()){placementObserver.disconnect();clearTimeout(placementTimeout);}});
 placementObserver.observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
 placementTimeout=setTimeout(()=>placementObserver.disconnect(),15000);
}});
const content=root.querySelector('[data-content]'),stage=root.querySelector('[data-stage]'),openButton=root.querySelector('[data-open]'),closeButton=root.querySelector('[data-close]');
// Copy supplied by the store owner; variant keys preserved.
const copy={
  "product.brand": "Kivora",
  "product.overline": "No pigment. Just your color.",
  "product.title": "The Lipstick That Makes Your Color",
  "product.benefit_1": "Goes on clear · your color in 8 seconds",
  "product.benefit_2": "Up to 8 hours · nothing on the cup",
  "launcher.badge": "QUIZ",
  "launcher.title": "Will Kivora work on my lips?",
  "launcher.subtitle": "7 questions · 2 min · straight answers to what you're wondering",
  "intro.brand": "Kivora",
  "intro.badge": "Your lip profile",
  "intro.title": "Tell us what made you stop.\nWe'll tell you what changed.",
  "intro.subtitle": "7 questions. 2 minutes. No fluff.",
  "intro.body": "The lines. The dryness. That moment in the mirror when it just looked like too much on you. If any of that is why you stopped wearing color, this was built for you — and we'll show you exactly how.",
  "intro.meta_1": "About 2 minutes",
  "intro.meta_2": "7 quick questions",
  "intro.meta_3": "No email needed",
  "intro.cta": "See if it's for me",
  "intro.footer": "Your answers never leave this page.",
  "question.progress_label": "Question {n} of 7",
  "question.counter": "{n}/7",
  "question.back": "Back",
  "question.hint": "Tap an answer to continue",
  "q1.title": "If a lipstick could fix one thing for you, what would it be?",
  "q1.a1": "Look like my own color, not paint",
  "q1.a2": "Stop drying my lips out",
  "q1.a3": "Stay out of the lines around my mouth",
  "q1.a4": "Still be there at four o'clock",
  "q2.title": "How do your lips feel most days?",
  "q2.a1": "Dry and tight — I live on balm",
  "q2.a2": "Fine in the morning, dry by afternoon",
  "q2.a3": "Comfortable, most of the time",
  "q3.title": "When you do wear color, what do you want people to see?",
  "q3.a1": "Nothing \"done.\" Just me, on a good day",
  "q3.a2": "A little warmth. A little glow",
  "q3.a3": "Real color. I like a lipstick that shows",
  "q4.title": "What made you give up on your last lipstick?",
  "q4.a1": "It bled into the little lines",
  "q4.a2": "It dried me out or felt heavy",
  "q4.a3": "It looked like too much on me",
  "q4.a4": "It was on my cup before it was on my lips",
  "q5.title": "How do you put lipstick on these days?",
  "q5.a1": "One quick swipe on the way out",
  "q5.a2": "Liner first, then fill — the way I always have",
  "q5.a3": "Honestly? I've mostly stopped",
  "q6.title": "What's the one thing you'd want to know before you order?",
  "q6.a1": "Will the color actually suit me?",
  "q6.a2": "Will it dry my lips out?",
  "q6.a3": "Will it creep into the lines?",
  "q6.a4": "What if it's not for me?",
  "q7.title": "And when would you wear it?",
  "q7.a1": "Every day, morning to night",
  "q7.a2": "With my liner, on my usual days",
  "q7.a3": "Just for the days I want a little something",
  "processing.title": "Putting your\nlip profile together…",
  "processing.status_1": "Reading what you told us…",
  "processing.status_2": "Matching it to how Kivora works…",
  "processing.status_3": "Writing your answers…",
  "processing.status_4": "Ready.",
  "processing.meta_1": "7 answers",
  "processing.meta_2": "Written for you",
  "processing.meta_3": "No email needed",
  "processing.check_1": "Understanding what made you stop",
  "processing.check_2": "Matching it to what Kivora does differently",
  "processing.check_3": "Preparing your answers",
  "result.badge": "Your profile is ready",
  "result.title": "Here's what we found",
  "result.circle_label": "Your look",
  "profile.a.name": "The Natural",
  "profile.a.description": "You don't want to look \"done.\" You want to look like you, on a good day. That's exactly what Kivora makes. No pigment goes on, so nothing can look painted. In 8 seconds it turns the color your lips already have — only warmer. Nobody sees lipstick. They see you.",
  "profile.b.name": "The Soft Glow",
  "profile.b.description": "You like a little warmth on your mouth — enough to look alive, never enough to look made up. Kivora goes on clear and comes up as a warm, soft rose built from your own lip. Put it on once. Wear it all day. It's still yours at four o'clock.",
  "profile.c.name": "Real Color",
  "profile.c.description": "You like a lipstick that shows — and somewhere along the way, somebody told you it was \"a lot\" on you. Here's the truth: that wasn't the color. It was the layer. Pigment in wax sits on top of the lip, so it shows and it moves. Kivora puts nothing on top. The color it makes is real, warm, and visible — it just comes from you instead of sitting on you. So it can't look like a lot. It only looks like yours.",
  "result.row_1.label": "What you want fixed",
  "result.row_2.label": "The look you're after",
  "result.row_3.label": "How you put it on",
  "result.row_4.label": "When you'll wear it",
  "q1.a1.benefit": "No pigment goes on. Nothing can look painted.",
  "q1.a2.benefit": "Hyaluronic acid and plant squalane. It wears like a balm.",
  "q1.a3.benefit": "There's no layer to bleed. The color is in your lip, not on it.",
  "q1.a4.benefit": "Up to 8 hours. The cup stays clean.",
  "q7.a1.benefit": "One pass in the morning. Up to 8 hours.",
  "q7.a2.benefit": "Keep your liner. Kivora goes on clear and won't fight it.",
  "q7.a3.benefit": "Ready when you are. Clear on, your color in 8 seconds.",
  "concern.a.title": "Will the color actually suit me?",
  "concern.a.body": "It can't not. Kivora has no pigment — none. It goes on clear, and the color that comes up in 8 seconds is made by your own lip, its warmth and its pH. That's why there's no shade to choose: you can't pick the wrong one, because nobody picks it. Every woman gets a different color, and every one of them suits the face it's on. Because it came from that face.",
  "concern.b.title": "Will it dry my lips out?",
  "concern.b.body": "This is the one thing we built it around. With time, lips hold less water — which is why ordinary lipstick, pigment in wax, feels like a dry film by noon. Kivora is made with serum-grade hyaluronic acid and plant-based squalane, and no pigment at all. It goes on like a balm and it stays like one. Care first. Color second.",
  "concern.c.title": "Will it creep into the lines?",
  "concern.c.body": "Lipstick bleeds because it's a layer: pigment in wax, sitting on top of the lip, with nowhere to go but out. Kivora doesn't put a layer down. It goes on clear, and the color develops in the lip itself. There is nothing on the surface to travel — so there is nothing to end up in the lines. The color stays where your lips are.",
  "concern.d.title": "What if it's not for me?",
  "concern.d.body": "Then you send it back. You have 90 days — long enough to wear it every day, through mornings, coffee, and long afternoons — and if it isn't your color, you return it for a full refund. Not store credit. Your money. And since the offer is buy one, get one free, you're deciding on two tubes with nothing at risk.",
  "routine.title": "A few honest words about wearing it",
  "application.a": "One swipe is the whole routine. It goes on clear, so there's no mirror to check and no edge to get right. Eight seconds later your color is up, and you're out the door.",
  "application.b": "Keep your liner if you love the ritual. Just know this: there's no layer here for a liner to hold back. Line for the shape if you like it. Kivora stays put with or without it.",
  "application.c": "You never decided to stop. One day it just looked like too much, and you stopped. That was never your mouth — it was the paint sitting on it. Kivora goes on with nothing that can look like too much. Try one swipe. See what comes up.",
  "comfort.a": "Put Kivora on the way you'd put balm on. It's made with hyaluronic acid and squalane and no pigment, so it wears like one — except this one leaves your color behind.",
  "comfort.b": "Afternoon dryness is usually the layer drying out, not your lips. Kivora has no layer — a balm base with hyaluronic acid and squalane, worn up to 8 hours. Put it on in the morning and leave it alone.",
  "comfort.c": "Your lips are in good shape, so the only question left is color. Kivora makes it from your own lip: clear on, your color in 8 seconds, up to 8 hours. Nothing to think about after that.",
  "disappointment.a": "That was the layer traveling. Kivora puts no layer down, so there's nothing to travel.",
  "disappointment.b": "That was pigment in wax. Kivora has no pigment — it's built on hyaluronic acid and squalane instead.",
  "disappointment.c": "That was never your mouth. It was the paint on top of it. Kivora's color comes from you, so it can't look like too much. Only like yours.",
  "disappointment.d": "That was the layer coming off. Kivora's color is in the lip, not on it. Up to 8 hours, and the cup stays clean.",
  "guarantee.number": "90",
  "guarantee.unit": "DAYS",
  "guarantee.title": "90 days to see your color. Or your money back.",
  "guarantee.body": "Wear Kivora every day for three months — mornings, coffee, long afternoons. If it isn't your color, send it back for a full refund.",
  "guarantee.promise": "If it isn't you, you don't keep it. That simple.",
  "guarantee.link_label": "Read the guarantee",
  "guarantee.link_url": "https://trykivora.co/policies/refund-policy",
  "result.cta": "Claim my Buy 1, Get 1 Free",
  "result.footer": "Kivora Signature Lipstick · 90-day money-back guarantee",
  "result.review": "Review my answers",
  "result.restart": "Start again",
  "offer.overline": "Your Kivora offer",
  "offer.title": "Two tubes. One price. No shade to pick.",
  "offer.single_title": "1 lipstick",
  "offer.single_subtitle": "Your color, one tube",
  "offer.bogo_title": "Buy 1, Get 1 Free",
  "offer.bogo_subtitle": "One for home. One for your purse.",
  "offer.footer": "90-day money-back guarantee · full refund",
  "a11y.preview_label": "Kivora quiz",
  "a11y.panel_label": "Kivora lip profile quiz",
  "a11y.close": "Close quiz",
  "a11y.progress": "Quiz progress",
  "a11y.guarantee": "90-day money-back guarantee"
};
Object.assign(copy,settings.overrides||{});
const config={guaranteeDays:90,guaranteeTitle:copy['guarantee.title'],guaranteeText:copy['guarantee.body'],guaranteePromise:copy['guarantee.promise'],guaranteeUrl:copy['guarantee.link_url'],cta:copy['result.cta'],processingMs:(settings.duration||5)*1000};
const questions=Array.from({length:7},(_,i)=>({title:copy[`q${i+1}.title`],options:Array.from({length:[4,3,3,4,3,4,3][i]},(_,j)=>copy[`q${i+1}.a${j+1}`])}));
const profiles=['a','b','c'].map(k=>({name:copy[`profile.${k}.name`],description:copy[`profile.${k}.description`]}));
const concerns=['a','b','c','d'].map(k=>({title:copy[`concern.${k}.title`],text:copy[`concern.${k}.body`]}));
const application=['a','b','c'].map(k=>copy[`application.${k}`]);
const comfort=['a','b','c'].map(k=>copy[`comfort.${k}`]);
const disappointment=['a','b','c','d'].map(k=>copy[`disappointment.${k}`]);
let state={view:'intro',index:0,answers:Array(7).fill(null),open:false,busy:false};
let advanceTimer=null,unlockTimer=null,animationFrame=null,runId=0;
const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
let previousOverflow=null;
const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const btn=(label,action,cls='primary')=>`<button type="button" class="${cls}" data-action="${action}">${label}</button>`;
function icons(){
 const paths={heart:'<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/>',sparkles:'<path d="m12 3 2.6 6.4L21 12l-6.4 2.6L12 21l-2.6-6.4L3 12l6.4-2.6L12 3Z"/>','clock-3':'<circle cx="12" cy="12" r="9"/><path d="M12 7v5h4"/>',sun:'<circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1 1m12 12 1 1M5 19l1-1M18 6l1-1"/>',check:'<path d="m5 12 4 4L19 6"/>'};
 root.querySelectorAll('[data-lucide]').forEach(el=>{el.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+(paths[el.dataset.lucide]||paths.check)+'</svg>';});
}
function cancelWork(){clearTimeout(advanceTimer);clearTimeout(unlockTimer);cancelAnimationFrame(animationFrame);advanceTimer=null;unlockTimer=null;animationFrame=null;runId++;state.busy=false;}
function focusAction(){const b=content.querySelector('[data-answer], [data-action="start"]');if(b)b.focus({preventScroll:true});else closeButton.focus({preventScroll:true});}
function render(){
 if(state.view==='intro'){
 content.innerHTML=`<div class="intro"><span class="pill"><i data-lucide="sparkles" aria-hidden="true"></i>${esc(copy['intro.badge'])}</span><h2>${esc(copy['intro.title']).replace(/\n/g,'<br>')}</h2><p class="lead">${esc(copy['intro.subtitle'])}</p><div class="short-rule"></div><p>${esc(copy['intro.body'])}</p><div class="meta-row"><span>${esc(copy['intro.meta_1'])}</span><span>${esc(copy['intro.meta_2'])}</span><span>${esc(copy['intro.meta_3'])}</span></div>${btn(esc(copy['intro.cta'])+' &nbsp; ›','start')}<p class="fine">${esc(copy['intro.footer'])}</p></div>`;icons();return;
 }
 if(state.view==='question'){
 const q=questions[state.index],a=state.answers[state.index];
 content.innerHTML=`<div class="question"><div class="question-meta"><span>${esc(copy['question.progress_label'].replace('{n}',state.index+1))}</span><span>${esc(copy['question.counter'].replace('{n}',state.index+1))}</span></div><div class="track" role="progressbar" aria-label="${esc(copy['a11y.progress'])}" aria-valuemin="0" aria-valuemax="7" aria-valuenow="${state.index+1}"><div class="track-fill" style="width:${(state.index+1)/7*100}%"></div></div><h2 aria-live="polite">${esc(q.title)}</h2><div class="options">${q.options.map((o,i)=>`<button type="button" class="option" data-answer="${i}" aria-pressed="${a===i}" ${state.busy?'disabled':''}><span class="radio" aria-hidden="true"></span>${esc(o)}</button>`).join('')}</div><div class="question-bottom">${btn('‹ '+esc(copy['question.back']),'back','quiet')}<span class="question-hint">${esc(copy['question.hint'])}</span></div></div>`;return;
 }
 if(state.view==='processing'){processing();return;}
 if(state.view==='result'){results();return;}
}
function ring(center,complete=false){return `<div class="ring"><svg viewBox="0 0 168 168" aria-hidden="true"><circle class="ring-bg" cx="84" cy="84" r="70"></circle><circle class="ring-value" cx="84" cy="84" r="70" ${complete?'style="stroke-dashoffset:0"':''}></circle></svg><div class="ring-copy">${center}</div></div>`;}
function processing(){
 cancelWork();const thisRun=runId;
 content.innerHTML=`<div class="processing">${ring('<span class="ring-percent" data-percent aria-live="off">0%</span>')}<h2>${esc(copy['processing.title']).replace(/\n/g,'<br>')}</h2><p class="processing-status" role="status" data-status>${esc(copy['processing.status_1'])}</p><div class="meta-row"><span>${esc(copy['processing.meta_1'])}</span><span>${esc(copy['processing.meta_2'])}</span><span>${esc(copy['processing.meta_3'])}</span></div><ul class="checklist"><li data-check="0"><span class="check" aria-hidden="true">✓</span>${esc(copy['processing.check_1'])}</li><li data-check="1"><span class="check" aria-hidden="true">✓</span>${esc(copy['processing.check_2'])}</li><li data-check="2"><span class="check" aria-hidden="true">✓</span>${esc(copy['processing.check_3'])}</li></ul></div>`;
 const start=performance.now(),duration=reduced()?150:config.processingMs;
 let lastStage=-1;
 function frame(now){
 if(!state.open||state.view!=='processing'||thisRun!==runId)return;
 const fraction=Math.min(1,(now-start)/duration),pct=Math.floor(fraction*100);
 content.querySelector('[data-percent]').textContent=pct+'%';
 content.querySelector('.ring-value').style.strokeDashoffset=String(439.823*(1-fraction));
 const st=pct<34?0:pct<70?1:pct<100?2:3;
 if(st!==lastStage){lastStage=st;content.querySelector('[data-status]').textContent=[1,2,3,4].map(n=>copy[`processing.status_${n}`])[st];content.querySelectorAll('[data-check]').forEach((li,i)=>li.dataset.done=String(i<st));}
 if(fraction<1){animationFrame=requestAnimationFrame(frame);}else{state.view='result';animationFrame=null;results();showResultTop();}
 }
 animationFrame=requestAnimationFrame(frame);
}
function results(){
 const a=state.answers;
 if(a.some(x=>x===null)){state.index=a.findIndex(x=>x===null);state.view='question';render();return;}
 const profile=profiles[a[2]],concern=concerns[a[5]];
 const rows=[['heart',copy['result.row_1.label'],questions[0].options[a[0]],copy[`q1.a${a[0]+1}.benefit`]],['sparkles',copy['result.row_2.label'],questions[2].options[a[2]],''],['clock-3',copy['result.row_3.label'],questions[4].options[a[4]],''],['sun',copy['result.row_4.label'],questions[6].options[a[6]],copy[`q7.a${a[6]+1}.benefit`]]];
 content.innerHTML=`<div class="result-head"><span class="pill"><i data-lucide="check" aria-hidden="true"></i>${esc(copy['result.badge'])}</span><h2>${esc(copy['result.title'])}</h2>${ring(`<span class="profile-label">${esc(copy['result.circle_label'])}</span><span class="profile-name">${esc(profile.name)}</span><span class="profile-check" aria-hidden="true">✓</span>`,true)}<p class="result-intro">${esc(profile.description)}</p></div><div class="profile-rows">${rows.map(([icon,label,value,benefit])=>`<div class="profile-row"><span class="row-icon"><i data-lucide="${icon}" aria-hidden="true"></i></span><div class="row-copy"><div class="row-label">${esc(label)}</div><div class="row-value">${esc(value)}</div>${benefit?`<p class="row-benefit">${esc(benefit)}</p>`:''}</div><span class="row-tick" aria-hidden="true">✓</span></div>`).join('')}</div><div class="answer-note"><h3>${esc(concern.title)}</h3><p>${esc(concern.text)}</p></div><div class="routine-note"><h3>${esc(copy['routine.title'])}</h3><p>${esc(application[a[4]])}</p><p>${esc(comfort[a[1]])} ${esc(disappointment[a[3]])}</p></div><div class="guarantee"><div class="guarantee-seal" aria-label="${esc(copy['a11y.guarantee'])}"><span class="guarantee-number">${config.guaranteeDays}</span><span class="guarantee-days">${esc(copy['guarantee.unit'])}</span></div><h3>${esc(config.guaranteeTitle)}</h3><p>${esc(config.guaranteeText)}</p><p class="promise">${esc(config.guaranteePromise)}</p><a href="${config.guaranteeUrl}" target="_blank" rel="noopener noreferrer">${esc(copy['guarantee.link_label'])}</a></div>${btn(esc(config.cta)+' &nbsp; ›','done')}<p class="fine">${esc(copy['result.footer'])}</p><div class="result-actions">${btn('‹ '+esc(copy['result.review']),'review','quiet')}${btn(esc(copy['result.restart']),'reset','quiet')}</div>`;icons();
}
function showResultTop(){stage.scrollTop=0;closeButton.focus({preventScroll:true});}
function close(){cancelWork();state.open=false;if(stage.open)stage.close();if(previousOverflow!==null){document.documentElement.style.overflow=previousOverflow;previousOverflow=null;}openButton.setAttribute('aria-expanded','false');if(root.isConnected)openButton.focus({preventScroll:true});}
function open(){if(state.open)return;state.open=true;render();previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';stage.showModal();stage.scrollTop=0;openButton.setAttribute('aria-expanded','true');closeButton.focus({preventScroll:true});if(state.view==='result')showResultTop();}
function goToOffer(){
 close();
 if(settings.offerUrl){window.location.assign(settings.offerUrl);return;}
 const main=document.querySelector('main')||document;
 let target=null;
 if(settings.offerSelector){try{target=main.querySelector(settings.offerSelector);}catch(_){}}
 if(!target){const form=main.querySelector('form[action*="/cart/add"]');target=form?form.closest('product-form')||form:null;}
 if(target){target.scrollIntoView({block:'center',behavior:reduced()?'instant':'smooth'});const focus=target.querySelector('button[type="submit"],button[name="add"],input,select');if(focus)focus.focus({preventScroll:true});}
 else if(settings.fallbackUrl){window.location.assign(settings.fallbackUrl);}
}
function onCancel(e){e.preventDefault();close();}
function onBackdrop(e){if(e.target===stage){const r=stage.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}}
stage.addEventListener('cancel',onCancel);stage.addEventListener('click',onBackdrop);
openButton.addEventListener('click',open);closeButton.addEventListener('click',close);
const onKeydown=e=>{if(e.key==='Escape'&&state.open){e.preventDefault();close();}if(e.repeat&&(e.key==='Enter'||e.key===' '))e.preventDefault();};root.addEventListener('keydown',onKeydown);
const onContentClick=e=>{
 const b=e.target.closest('button');if(!b||b.disabled)return;
 if(b.dataset.answer!==undefined){
 if(state.view!=='question'||state.busy||e.detail>1)return;
 const answer=Number(b.dataset.answer);if(!Number.isInteger(answer)||answer<0||answer>=questions[state.index].options.length)return;
 state.answers[state.index]=answer;state.busy=true;
 content.querySelectorAll('[data-answer]').forEach(el=>{el.setAttribute('aria-pressed',String(Number(el.dataset.answer)===answer));el.disabled=true;});
 advanceTimer=setTimeout(()=>{
 advanceTimer=null;if(!state.open)return;
 state.index++;
 if(state.index===questions.length){state.view='processing';render();closeButton.focus({preventScroll:true});return;}
 render();
 unlockTimer=setTimeout(()=>{state.busy=false;unlockTimer=null;content.querySelectorAll('[data-answer]').forEach(el=>el.disabled=false);focusAction();},180);
 },reduced()?0:210);return;
 }
 const action=b.dataset.action;
 if(action==='done'){goToOffer();return;}
 cancelWork();
 if(action==='start'){state.view='question';state.index=0;}
 if(action==='back'){if(state.index===0)state.view='intro';else{state.index--;state.view='question';}}
 if(action==='review'){state.view='question';state.index=0;}
 if(action==='reset'){state.answers.fill(null);state.index=0;state.view='intro';}
 render();focusAction();
};content.addEventListener('click',onContentClick);

return ()=>{cancelAnimationFrame(placementFrame);if(placementObserver)placementObserver.disconnect();clearTimeout(placementTimeout);root.removeEventListener('keydown',onKeydown);content.removeEventListener('click',onContentClick);cancelWork();if(stage.open)stage.close();if(previousOverflow!==null){document.documentElement.style.overflow=previousOverflow;previousOverflow=null;}openButton.removeEventListener('click',open);closeButton.removeEventListener('click',close);stage.removeEventListener('cancel',onCancel);stage.removeEventListener('click',onBackdrop);};
}
if(!customElements.get('kivora-quiz')){
 customElements.define('kivora-quiz',class extends HTMLElement{
  connectedCallback(){if(this._quizCleanup||this._quizPending)return;this._quizPending=true;queueMicrotask(()=>{this._quizPending=false;if(this.isConnected&&!this._quizCleanup)this._quizCleanup=initializeKivoraQuiz(this);});}
  disconnectedCallback(){if(this._quizCleanup){this._quizCleanup();this._quizCleanup=null;}}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
